import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Badges from "./components/Badges";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import Venture from "./components/Venture";
import Projects from "./components/Projects";
import OpenSource from "./components/OpenSource";
import CTA from "./components/CTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="font-sans min-h-screen relative">
      <div className="fixed inset-0 z-[-1] pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-white" />
        <div className="absolute inset-0 bg-premium-grid" />
        <div
          className="absolute -right-8 top-24 h-72 w-40 rotate-[8deg] border-2 border-black/10 hidden md:block"
          aria-hidden="true"
        />
        <div
          className="absolute left-[6%] bottom-32 h-24 w-24 border-2 border-black/10 rotate-45 hidden lg:block"
          aria-hidden="true"
        />
      </div>

      <Navbar />
      <Hero />
      <Badges />
      <Services />
      <Pricing />
      <Venture />
      <Projects />
      <OpenSource />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}
